export const PRICE_LIST_MAX_FILE_SIZE = 5 * 1024 * 1024;
export const PRICE_LIST_ACCEPT = ".csv,.xml";

export const PRICE_LIST_FORMAT_LABELS = {
    0: "CSV",
    1: "XML",
};

export const PRICE_LIST_STATUS = {
    CURRENT: "current",
    SCHEDULED: "scheduled",
    ARCHIVED: "archived",
};

export const PRICE_LIST_STATUS_BADGES = {
    [PRICE_LIST_STATUS.CURRENT]: { label: "Važeći", colorScheme: "green" },
    [PRICE_LIST_STATUS.SCHEDULED]: { label: "Zakazan", colorScheme: "blue" },
    [PRICE_LIST_STATUS.ARCHIVED]: { label: "Arhiva", colorScheme: "gray" },
};

// Upload/update errors come back as plain English text (400) - map the known
// ones so the user sees Croatian, and fall back to the raw text otherwise.
const ERROR_TRANSLATIONS = {
    "A .csv or .xml file is required.": "Potrebna je .csv ili .xml datoteka.",
    "Only .csv and .xml files are allowed.": "Dopuštene su samo .csv i .xml datoteke.",
    "The file is empty.": "Datoteka je prazna.",
    "The file is larger than 5 MB.": "Datoteka je veća od 5 MB.",
    "The XML file is not well-formed.": "XML datoteka nije ispravno oblikovana.",
    "Price list not found.": "Cjenik nije pronađen.",
};

export const translatePriceListError = (err, fallback) => {
    const data = err?.response?.data;
    if (typeof data === "string" && data.trim()) {
        return ERROR_TRANSLATIONS[data.trim()] ?? data;
    }
    return fallback;
};

// "Today" for price lists is the Croatian calendar day, regardless of where
// the admin's browser is - the backend defaults and publishes by Zagreb time.
export const zagrebToday = () =>
    new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Zagreb" }).format(new Date());

// validForDate comes as "2026-10-01T00:00:00" - only the date part matters.
export const toDateOnly = (value) => (value ? value.slice(0, 10) : "");

export const formatDateOnly = (value) => {
    const date = toDateOnly(value);
    if (!date) return "-";
    const [year, month, day] = date.split("-");
    return `${day}.${month}.${year}.`;
};

export const formatFileSize = (bytes) => {
    if (bytes == null) return "-";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

// The list is sorted newest first (validForDate desc, createdAt desc), so the
// first non-future entry is the one publicly valid today.
export const getPriceListStatuses = (priceLists, today = zagrebToday()) => {
    const statuses = {};
    let currentFound = false;
    priceLists.forEach((priceList) => {
        if (toDateOnly(priceList.validForDate) > today) {
            statuses[priceList.id] = PRICE_LIST_STATUS.SCHEDULED;
        } else if (!currentFound) {
            statuses[priceList.id] = PRICE_LIST_STATUS.CURRENT;
            currentFound = true;
        } else {
            statuses[priceList.id] = PRICE_LIST_STATUS.ARCHIVED;
        }
    });
    return statuses;
};

export const isPublished = (priceList, today = zagrebToday()) =>
    toDateOnly(priceList.validForDate) <= today;
